import { apiRequest } from '@/utils/api-request';

export interface WorkflowLockResponse {
  workflow_id: string;
  is_locked: boolean;
  locked_by?: {
    id: string;
    name?: string;
    email?: string;
  };
  locked_at?: string;
  detail?: string;
}

export async function lockWorkflow(
  orgId: string,
  workflowId: string,
  isLocked: boolean,
): Promise<WorkflowLockResponse> {
  const response = await apiRequest<WorkflowLockResponse>({
    url: `/api/v1/orgs/${orgId}/workflows/${workflowId}/lock`,
    method: 'POST',
    target: 'workflow',
    body: { is_locked: isLocked },
  });

  if (response.detail) {
    throw new Error(response.detail);
  }

  if (!response.data) {
    throw new Error('Empty response from lock endpoint');
  }

  return response.data;
}
